<mat-toolbar class="main-header">
  <mat-toolbar-row class="primary-header">
    <div class="left-buttons">
      <button [routerLink]="['/home']">
        Business Hub
      </button>

    </div>
    <div class="right-buttons">
      <button mat-raised-button *ngIf="loginDisplay && appCount > 1" [routerLink]="['/select-app']">
        <mat-icon>swap_horiz</mat-icon>
        Switch App
      </button>
      <button mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>
      <button mat-raised-button *ngIf="loginDisplay" (click)="logout()">Logout</button>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row *ngIf="loginDisplay" class="secondary-header">
    <div class="left-buttons">
      <button mat-button [routerLink]="['/dashboard/home']">
        <mat-icon>home</mat-icon>
        My Boards
      </button>
      <button mat-button [routerLink]="['/dashboard/my-tables']">
        <mat-icon>table_chart</mat-icon>
        My Tables
      </button>
      <button mat-button [routerLink]="['/dashboard/custom-views']">
        <mat-icon>dashboard_customize</mat-icon>
        Custom Views
      </button>
      <button mat-button [routerLink]="['/dashboard/data-entry']">
        <mat-icon>drive_file_move</mat-icon>
        Data Entry
      </button>
      <button mat-button [routerLink]="['/dashboard/files']">
        <mat-icon>folder</mat-icon>
        Files
      </button>
      <!-- <button mat-button [routerLink]="['/dashboard/about']">
        <mat-icon>info</mat-icon>
        About
      </button> -->
      <button mat-button [routerLink]="['/dashboard/admin']" *ngIf="hasAdminAccess()">
        <mat-icon>verified_user</mat-icon>
        Admin
      </button>
    </div>
    <button mat-button [routerLink]="['/dashboard/help']">
      <mat-icon>help</mat-icon>
      Help
    </button>
  </mat-toolbar-row>
</mat-toolbar>
